import "./CourseSummary.css";
import React, { useContext, useMemo, useState } from "react";
import { CurrentUserContext } from "../../../contexts/CurrentUserContext";
import LessonList from "./LessonList";

function CourseSummary({ course, isLessonAll }) {
  const [isListDisplayed, setListDisplayed] = useState(false);
  const { currentUser } = useContext(CurrentUserContext);

  const lessons = useMemo(
    () => isLessonAll.filter((lesson) => lesson.unit === course._id),
    [isLessonAll, course._id]
  );

  const { progress } = useMemo(() => {
    const totalLessons = lessons.length;
    const completedLessons = lessons.filter((l) =>
      l.completedBy.includes(currentUser._id)
    ).length;
    return {
      progress: totalLessons > 0 ? Math.round((completedLessons / totalLessons) * 100) : 0,
    };
  }, [lessons, currentUser._id]);

  const toggleListDisplay = () => setListDisplayed((v) => !v);

  // Уникальный id для связки progress + label
  const progressId = useMemo(() => `progress-course-${course._id}`, [course._id]);

  return (
    <li className="course-summary">
      <button
        className="course-summary__button-status"
        onClick={toggleListDisplay}
        type="button"
      >
        <div className="course-summary__title-block">
          <h2 className="course-summary__title">{course.title}</h2>
          <p className="course-summary__description">{course.description}</p>
        </div>

        <div className="course-summary__progress-block">
          <progress
            className="course-summary__progress"
            value={progress}
            max="100"
            id={progressId}
          />
          <label
            className="course-summary__progress-percentages"
            htmlFor={progressId}
          >
            {`${progress}%`}
          </label>
        </div>
      </button>

      <ol
        className={`course-summary__list-subtitle ${
          isListDisplayed ? "course-summary__list-subtitle_active" : ""
        }`}
      >
        {isLessonAll
          .filter((item) => item.unit === course._id)
          .map((item) => (
            <LessonList key={item._id} lesson={item} courseId={course._id} />
          ))}
      </ol>
    </li>
  );
}

export default CourseSummary;
